import moment from "moment";
import { Role } from "@/helper/Role";
import { authenticationService } from "@/services/AuthenticationService";
import Vue from "vue";
import _ from "lodash";

export const getPermissions = function(
  permissions,
  access,
  redirect,
  moduleID,
  accessID
) {
  let roleArray = [];
  let checkperm = false;

  let modules = [];

  let roleID = null;

  if (authenticationService.get("USINFO")) {
    roleID = authenticationService.get("USINFO").role_id;
  }
  let module_list = authenticationService.get("module_list");
  // console.log('module_list :>> ', module_list);

  if (roleID == 1 || roleID == 2 || roleID == 3 || roleID == 8 || roleID == 9) {
    return (checkperm = true);
  } else if (
    roleID != 1 &&
    roleID != 2 &&
    roleID != 3 &&
    roleID != 4 &&
    roleID != 5 &&
    roleID != 6 &&
    roleID != 7 &&
    roleID != 8 &&
    roleID != 9
  ) {
    if (module_list && module_list.includes(moduleID)) {
      checkperm = true;
    } else {
      let promise = permissions.map(x => {
        if (Role.hasOwnProperty(x)) {
          roleArray.push({
            role: Role[x],
            access: access,
            redirect: redirect
          });
        }
        return x;
      });
      Promise.all(promise);
      return roleArray;
    }
  } else {
    let promise = permissions.map(x => {
      if (Role.hasOwnProperty(x)) {
        roleArray.push({
          role: Role[x],
          access: access,
          redirect: redirect
        });
      }
      return x;
    });
    Promise.all(promise);
    return roleArray;
  }
};

export const addAllKeyWordsIntoArrays = (array, key) => {
  if (array.length > 0) {
    let Obj = { ...array[0] };
    Object.keys(Obj).map(x => {
      Obj[x] = null;
      key ? (Obj[key] = "All") : "";
    });
    return [Obj].concat(array);
  } else return array;
};

export const addAllKeyWordsIntoArrays_2 = (array, key) => {
  if (array.length > 0) {
    let Obj = { ...array[0] };
    Object.keys(Obj).map(x => {
      Obj[x] = null;
      key ? (Obj[key] = "All") : "";
    });
    return [Obj].concat(array);
  } else return array;
};

export const generateRandomCode = max => {
  return Math.floor(
    Math.pow(10, max - 1) +
      Math.random() * (Math.pow(10, max) - Math.pow(10, max - 1) - 1)
  );
  // return Array(max).fill('').reduce((accumulator) => accumulator += Math.floor(Math.random() * (max - 2) + 2), '');
};

export const UniqueRandomNumber = () => {
  let u_number = Math.floor(new Date().valueOf() * Math.random());
  return new String(u_number).substring(0, 8);
};

export const createUniqueReceiptCodeWithDate = (date) => {
  return `${moment(date).format("YYMMDDHHmm")}${Math.floor(
    Math.random() * 8999 + 1000
  )}`;
};

export const randomAlphaNumeric = () => {
  return `${moment().format("YYMMDDHHmm")}${Math.floor(
    Math.random() * 8999 + 1000
  )}`;
};

export const removeDuplicates = (originalArray, prop) => {
  var newArray = [];
  var lookupObject = {};

  for (var i in originalArray) {
    lookupObject[originalArray[i][prop]] = originalArray[i];
  }

  for (i in lookupObject) {
    newArray.push(lookupObject[i]);
  }
  return newArray;
};

export const movieWeekEnd = date => {
  const dayINeed = 5;
  let startDate = moment(date);
  let FinalDate = null;
  if (startDate.isoWeekday() === 5) {
    startDate.add(1, "days");
  }
  while (startDate.isoWeekday() !== dayINeed) {
    let d = startDate;
    FinalDate = d.format();
    startDate.add(1, "days");
  }
  return FinalDate;
};

export const getSeatLayoutModified = (
  flatSeats = [],
  screen_seat_type = [],
  oldSeatlayout = []
) => {
  let seatsRowsRaw = [];

  /** get the grid */
  seatsRowsRaw = _(flatSeats)
    .groupBy(item => String(item.sl_row_num).padStart(4, "0"))
    .sortBy(group => flatSeats.indexOf(group[0]))
    .value()
    .map(row => {
      row.forEach(singleSeat => {
        singleSeat.selectStatus = singleSeat.SelectStatusFlag = false;
      });
      /** sorting by col asc for each row, just in case */
      return row.sort((a, b) => a.sl_col_num - b.sl_col_num);
    });

  let ssts = [];
  let sstsPayload = Array.from(screen_seat_type);
  let ssts_seats = [];
  let seatsRowsRawPrevIndex = 0;
  let seatsRowsRawlength = seatsRowsRaw.length;

  /** get sst seat types from the grid */
  seatsRowsRaw.forEach((row, index) => {
    let sst = sstsPayload.filter(x => x.sst_id == row[0].sst_id);
    if (ssts.length > 0 && ssts[ssts.length - 1].sst_id != row[0].sst_id) {
      ssts.push(sst[0]);
    }
    if (ssts.length == 0) {
      ssts.push(sst[0]);
    }
    /** get seat slice for sst seat types of the grid */
    const rowNext = seatsRowsRaw[index + 1];
    if (rowNext && row[0].sst_id != rowNext[0].sst_id) {
      ssts_seats.push(getSubarray(seatsRowsRaw, seatsRowsRawPrevIndex, index));
      seatsRowsRawPrevIndex = index + 1;
    }
    if (rowNext == undefined) {
      ssts_seats.push(getSubarray(seatsRowsRaw, seatsRowsRawPrevIndex, index));
      seatsRowsRawPrevIndex = seatsRowsRawlength;
    }
  });

  if (ssts.length !== ssts_seats.length) {
    //   throw new Error('something went wrong with the seats array, ssts, ssts_seats doesnt match')
    return oldSeatlayout;
  }

  /** zip seat slice into sst seat types of the grid */
  return _.zipWith(ssts, ssts_seats, function(types, seats) {
    return {
      ...types,
      seatType: types.sst_seat_type,
      seat_net_price: seats.flatMap(x => x)[0].seat_net_price || "",
      seat_price: seats.flatMap(x => x)[0].seat_price || "",
      seats: seats.flatMap(x => x),
      seatsFinal: seats.map(x => x),
      debug: seats
        .flatMap(x => x)
        .map(x => x.sl_seat_name)
        .join(",")
    };
  });
};

const getSubarray = (array = [], fromIndex = 0, toIndex = 0) => {
  let a = array;
  return a.slice(fromIndex, toIndex + 1);
};



// WEBPACK FOOTER //
// ./src/helper/collection.js